import produce from 'immer'
import merge from 'lodash/merge'
import {ENTITIES} from 'actions'

const reducer = (state = {}, {type, response}) => {
  if (type === ENTITIES) {
    return response ? produce(state, draftState => merge({}, draftState, response)) : state
  }
  return state
}

export default reducer
